import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-primary w-52 h-16 rounded-3xl flex justify-center items-center" }

import { Handle, NodeProps, Position } from '@vue-flow/core';
import { CornerRightDown } from 'lucide-vue-next';


interface LinkIncomingProps {
  id: string;
  content: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkIncoming',
  props: {
    id: {},
    type: {},
    selected: { type: Boolean },
    connectable: { type: [Boolean, Number, String, Function] },
    position: {},
    dimensions: {},
    label: {},
    isValidTargetPos: { type: Function },
    isValidSourcePos: { type: Function },
    parent: {},
    parentNodeId: {},
    dragging: { type: Boolean },
    resizing: { type: Boolean },
    zIndex: {},
    targetPosition: {},
    sourcePosition: {},
    dragHandle: {},
    data: {},
    events: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(CornerRightDown), {
        size: 20,
        color: "#FFFFFF"
      }),
      _createTextVNode(" " + _toDisplayString(props.data.content), 1)
    ]),
    _createVNode(_unref(Handle), {
      id: `${props.data.id}_B`,
      type: "target",
      position: _unref(Position).Bottom
    }, null, 8, ["id", "position"])
  ], 64))
}
}

})